import type { PropsWithChildren, ReactNode } from "react";
import { styled } from "@pigment-css/react";

const Screen = styled("main")(({ theme }) => ({
  boxSizing: "border-box",
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-end",
  gap: theme.fieldSalesTwo.spacing[32],
  minHeight: "100vh",
  width: "100%",
  padding: `${theme.fieldSalesTwo.spacing[24]} ${theme.fieldSalesTwo.spacing[20]} ${theme.fieldSalesTwo.spacing[32]}`,
  background: theme.fieldSalesTwo.colors.background,
}));

const Logo = styled("img")({
  display: "block",
  width: 200,
  height: "auto",
});

const Copy = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.fieldSalesTwo.spacing[16],
  color: theme.fieldSalesTwo.colors.neutral[800],
  fontFamily: theme.fieldSalesTwo.font.family,
  fontSize: theme.fieldSalesTwo.font.size[17],
  fontWeight: theme.fieldSalesTwo.font.weight[500],
  lineHeight: theme.fieldSalesTwo.font.lineHeight[140],
  letterSpacing: theme.fieldSalesTwo.font.letterSpacing.tight,
  "& p": { margin: 0 },
}));

const Actions = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.fieldSalesTwo.spacing[12],
}));

interface PreAuthScreenProps extends PropsWithChildren {
  actions: ReactNode;
}

export function PreAuthScreen({ children, actions }: PreAuthScreenProps) {
  return (
    <Screen>
      <Logo src="/assets/acto-logo-combined.svg" alt="Acto logo" />
      <Copy>{children}</Copy>
      <Actions>{actions}</Actions>
    </Screen>
  );
}
